export default __webpack_public_path__ + "static/11-8e1d870b568a2b869a62b577879c56df.png";